import * as yup from 'yup';
import { PortalNotificationType } from '../../types/PortalNotificationType';
export const createPortalNotificationSchema = yup.object({
    titleENUS: yup.string().max(50),
    contentENUS: yup.string().max(250).required(),
    titleENCA: yup.string().max(50),
    contentENCA: yup.string().max(250).required(),
    titleFRCA: yup.string().max(50),
    contentFRCA: yup.string().max(250).required(),
    titleENGB: yup.string().max(50),
    contentENGB: yup.string().max(250).required(),
    type: yup.string().oneOf(['Success', 'Error', 'Info', 'Warning']).default('Info'),
    scheduledStart: yup.date().required(),
    scheduledEnd: yup.date().required(),
    isDismissable: yup.bool(),
    isActive: yup.bool(),
    canDelete: yup.bool(),
});
export const updatePortalNotificationSchema = yup.object({
    id: yup.number().required(),
    titleENUS: yup.string().max(50),
    contentENUS: yup.string().max(250).default('').required(),
    titleENCA: yup.string().max(50),
    contentENCA: yup.string().max(250).default('').required(),
    titleFRCA: yup.string().max(50),
    contentFRCA: yup.string().max(250).default('').required(),
    titleENGB: yup.string().max(50),
    contentENGB: yup.string().max(250).default('').required(),
    type: yup.mixed().oneOf(Object.values(PortalNotificationType)),
    scheduledStart: yup.date(),
    scheduledEnd: yup.date(),
    isDismissable: yup.bool(),
    isActive: yup.bool(),
    canDelete: yup.bool(),
});
//# sourceMappingURL=portalNotification.js.map